import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first, firstValueFrom } from 'rxjs';
import { SourcesApiService } from '../apis/sources-api.service';
import { DottedDropdownAction } from '../dotted-dropdown/dotted-dropdown.component';
import { LocalStorageService } from '../lib/local-storage.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { Source } from '../model/source';
import { SourceModalComponent } from '../source-modal/source-modal.component';

@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.scss']
})
export class SourceComponent implements OnInit {

  public data: Source[] = [];

  @ViewChild('modal') modal!: SourceModalComponent;
  @ViewChild('deleteModal') deleteModal!: ModalDialogComponent;

  search: string = "";
  selectedTag: Source = new Source();

  public actions: DottedDropdownAction[] = [];

  constructor(private translate: TranslateService,
    private service: SourcesApiService,
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    this.loadActions();

    this.service
      .getAllSources(parseInt(this.localStorageService.getRestaurantId() + ""))
      .pipe(first())
      .subscribe((resp) => {
        this.data = resp.sources
          .filter(a => a.typeOfVisit !== "ONLINE_RESERVATION")
          .sort((a, b) => {
            const title = (a?.companyTitle ?? "").localeCompare(b.companyTitle ?? "");
            if (title != 0) {
              return title;
            }
            const surname = (a?.contactSurname ?? "").localeCompare(b.contactSurname ?? "");
            if (surname != 0) {
              return surname;
            }
            return (a?.contactName ?? "").localeCompare(b.contactName ?? "");;
          })
      });
  }

  showDeleteModal(context: Source) {
    this.selectedTag = { ...context };
    this.deleteModal.show();
  }

  showAddModal() {
    this.selectedTag = new Source();
    this.modal.show();
  }

  editTag(context: Source): void {
    this.selectedTag = { ...context };
    this.modal.show();
  }

  clearSearch() {
    this.search = "";
  }

  modalClosed(updated: Source): void {
    const existing = this.data.find(i => i.id == updated.id);

    if (existing == null) {
      this.data.push({ ...updated });
    } else {
      existing!.companyTitle = updated.companyTitle;
      existing!.contactName = updated.contactName;
      existing!.contactMail = updated.contactMail;
      existing!.contactTelephone = updated.contactTelephone;
      existing!.contactSurname = updated.contactSurname;
    }
  }

  deleteModalClosed(ok: boolean) {
    if (ok == false) {
      return;
    }

    const existing = this.data.findIndex(i => i.id == this.selectedTag.id);
    this.data.splice(existing, 1);
  }

  loadActions = async () => {
    const justToLoadTranslations = await firstValueFrom(this.translate.get('report.status.completed'));
    this.actions = [
      { name: this.translate.instant('common.buttons.edit'), color: 'default', action: (context: Source) => this.editTag(context) },
      { name: this.translate.instant('common.buttons.delete'), color: 'danger', action: (context: Source) => this.showDeleteModal(context) }
    ]
  }

}
